import React from "react";
import {
 Navbar,
 Nav,
 Button,
 Container
} from 'react-bootstrap'
 
const Navigation = () => {
 
 return (
   <Navbar bg="secondary" variant="dark" expand="md" className="ml-2">
    <Container>
     <Navbar.Brand href="/">BRETT BARTHOLOMEW</Navbar.Brand>
     <Navbar.Toggle aria-controls="basic-navbar-nav" />
     <Navbar.Collapse id="basic-navbar-nav">
       <Nav className="w-100 justify-content-end">
         <Button href="https://github.com/brettbart?tab=repositories" target="_blank" rel="noopener noreferrer">PROJECTS</Button>&nbsp;
         <Button href="mailto:nospam@brettbartholomew.com">CONTACT</Button>
       </Nav>
     </Navbar.Collapse>
     </Container>
   </Navbar>
 );
};
export default Navigation;